/**
 * React ↔ Google Translate compatibility polyfill.
 *
 * Problem: Google Translate walks the DOM and replaces text nodes in-place.
 * React keeps references to the original text nodes for its virtual-DOM
 * reconciler. When React later tries to remove or reinsert one that Google
 * has already moved, `Node.removeChild` / `Node.insertBefore` throw:
 *   "Failed to execute 'removeChild' on 'Node': The node to be removed
 *    is not a child of this node."
 *
 * This polyfill makes both APIs fail *silently* (returning the node) instead
 * of throwing — the industry-standard workaround used by Airbnb, Coursera,
 * Notion, etc. React continues to render the next frame correctly.
 *
 * See: https://github.com/facebook/react/issues/11538
 */
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      if (typeof console !== 'undefined') {
        console.warn(
          '[Google Translate] Swallowed removeChild race — parent mismatch.',
          child,
          this
        );
      }
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (typeof console !== 'undefined') {
        console.warn(
          '[Google Translate] Swallowed insertBefore race — parent mismatch.',
          referenceNode,
          this
        );
      }
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

export {};
